// Vendor imports
const Promise = require('bluebird')
const qs = require('qs')
// Shared imports
const { parseTemplate } = require('shared/model-helpers/meta-template')
// Client lib imports
const businessEvents = require('client/lib/business-events')
const { send: ajax } = require('client/lib/request')

const API = {
  fetchComments: async function (urlId) {
    if (!urlId) {
      throw new Error('`url_id` is required to fetch comments')
    }
    return ajax({
      url: `/api/v0.1/comments/id/${urlId}`,
      method: 'get',
      data: { client: 1 }
    })
  },

  fetchInterests: async function (urlHash) {
    if (!urlHash) {
      throw new Error('Article `hash` is required to fetch interests')
    }
    const interests = []
    const {
      url: { topics, categories }
    } = await ajax({ url: `/api/v0.2/url/${urlHash}` })
    if (topics) {
      topics.forEach(topic => {
        interests.push({ ...topic, type: 'interest' })
      })
    }
    if (categories) {
      categories.forEach(category => {
        interests.push({ ...category, type: 'category' })
      })
    }
    return { interests }
  },

  addComment: async function (urlId, text, { pageContext } = {}) {
    if (!urlId) {
      throw new Error('`url_id` is required for comment submission')
    }
    if (!text) {
      throw new Error('`text` is required for comment submission')
    }
    const data = { 'url_id': urlId, text }
    if (pageContext) {
      data['page_context'] = pageContext
    }
    const response = await ajax({
      url: '/api/v0.1/conversation',
      method: 'post',
      data
    })
    // Send tracking call
    await businessEvents.trackSegment('comment', {
      'url': urlId, // QUESTION: Shouldn't this be 'url_id'?
      'text_length': text.length,
      'comment_id': response.id
    }, {
      pageContext
    })
    return response
  },

  deleteComment: async function (urlId, commentId) {
    const response = await ajax({
      url: `/api/v0.1/comment/${commentId}`,
      method: 'delete'
    })
    await businessEvents.trackSegment('delete-comment', {
      'url_id': urlId
    })
    return response
  },

  reportComment: async function (urlId, commentId, reporterId) {
    await ajax({
      url: '/api/v0.1/reports/comment',
      method: 'post',
      data: {
        context: 'flag',
        'reported_id': commentId
      }
    })
    await businessEvents.trackSegment('report-comment', {
      'comment_id': commentId,
      'reporter_id': reporterId,
      'url_id': urlId
    })
  },

  fetchUrlMixHistoryV1: async function (urlId, options = {}) {
    if (!urlId) {
      throw new Error('`urlId` is required')
    }
    const { nextUrl, page, limit } = options
    const url = nextUrl || `/api/v0.1/url/mixes/${urlId}/history/${page || 1}`
    const query = qs.stringify({ limit })
    return ajax({
      url: `${url}?${query}`,
      method: 'get'
    })
    .then(({ curator, 'url_mixers': urlMixers, meta }) => {
      // Normalize and parse the reponse templates
      const items = [].concat(
        curator ? normalizeUrlHistoryMixer(curator, true) : [],
        urlMixers.map(urlMixer => normalizeUrlHistoryMixer(urlMixer))
      )
      return { items, meta }
    })

    function normalizeUrlHistoryMixer(urlMixer, isCurator = false) {
      const html = parseTemplate(urlMixer)
      return { ...urlMixer, html, isCurator }
    }
  },

  fetchUrlMixHistoryV2: async function (urlId, options = {}) {
    if (!urlId) {
      throw new Error('`urlId` is required')
    }
    const { nextUrl, page, limit } = options
    const url = nextUrl || `/api/v0.2/url/mixes/${urlId}/history/${page || 1}`
    const query = qs.stringify({ limit })
    return ajax({
      url: `${url}?${query}`,
      method: 'get'
    })
  },

  fetchRelatedArticles: function (urlId, options = {}) {
    if (!urlId) {
      return Promise.reject(new Error('`urlId` is required'))
    }
    const { nextUrl, page, limit, recBatchId } = options
    const url = nextUrl || `/api/v0.1/url/${urlId}/related/${page || 1}`
    const query = qs.stringify({ limit, recBatchId })
    return ajax({
      url: `${url}?${query}`,
      method: 'get'
    })
  }
}

module.exports = { API }
